import React, { useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Profile from "../Pdfgenarot/Profile"
import Button from "react-bootstrap/Button";
import imge1 from "../../Assets/Imge1.jpg";
import imge2 from "../../Assets/Imge2.jpg";
import imge3 from "../../Assets/Imge3.jpg";
import imge4 from "../../Assets/Imge4.jpg";
import CarouselSteps from "../Corousl"
import Reset from "../../Assets/reset.png"
import Nav from "react-bootstrap/Nav";
import Type from "./Type";
import Form from "../Form/form"
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

import TemplateEditor from "../../components/Template/Templates"



const faqData = [
  {
    question: "Is Creating a Biodata Really Free?",
    answer:
      "Absolutely! Our platform offers the freedom to create your marriage biodata without any charges. Enjoy a hassle-free experience with no hidden costs. But we would highly appreciate if you will give us some feedback.",
  },
  {
    question: "How Simple is the Biodata Creation Process?",
    answer:
      "Creating your biodata is as easy as 1-2-3. Our user-friendly interface ensures a straightforward and simple process, guiding you through each step seamlessly.",
  },
  {
    question: "What Sets Your Designs Apart?",
    answer:
      "Our designs are not just visually appealing—they're the latest in matrimonial trends. We blend tradition with modernity, providing a stunning backdrop for your love story.",
  },
  {
    question: "Are the Designs High-Quality?",
    answer:
      "Absolutely! We take pride in delivering high-quality designs to ensure your marriage biodata reflects the significance of your journey with elegance and precision.",
  },
  {
    question: "Can I Preview Before Finalizing?",
    answer:
      "Yes, you can preview your biodata before downloading or sharing. This way, you can be sure everything looks just the way you want.",
  },
];




function Home() {
  const [Cropeiagmefile, setCropeimgefile] = useState(null);
  const [showTemlate, setShotemlpate] = useState(false)
  const formRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const [Fakedata, setFormData] = useState({

    Previewsssss: [
      { key: "Name", value: "NIrakar", editable: false },
      { key: "Birthday", value: "10/09/1997", editable: false },
      { key: "Color", value: "Fair", editable: false }
    ],
    Previe: [
      { key: "fatherName", value: "Fadfafaf", editable: true },
      { key: "MotherName", value: "dfgasdfa", editable: true }
    ]
  });
  const scrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: 'smooth' });
  };
  const transformData = (data) => {
    const transformedData = {};

    Object.keys(data).forEach((sectionKey) => {
      transformedData[sectionKey] = {};
      data[sectionKey].forEach((field) => {
        transformedData[sectionKey][field.key] = field.value;
      });
    });

    return transformedData;
  };
  const updateData = (sectionKey, index, value) => {
    const updatedSection = [...Fakedata[sectionKey]];
    updatedSection[index].value = value;
    setFormData((prevState) => ({
      ...prevState,
      [sectionKey]: updatedSection
    }));
  };


  const addField = (sectionKey) => {
    const newField = { key: "Enter Filed Name", value: "Enter Filed Value", editable: true };
    setFormData((prevState) => ({
      ...prevState,
      [sectionKey]: [...prevState[sectionKey], newField]
    }));
  };

  const handleKeyChange = (sectionKey, index, newKey) => {
    const updatedSection = [...Fakedata[sectionKey]];
    updatedSection[index].key = newKey;
    setFormData((prevState) => ({
      ...prevState,
      [sectionKey]: updatedSection
    }));
  };

  const deleteField = (sectionKey, index) => {
    const updatedSection = Fakedata[sectionKey].filter((_, i) => i !== index);
    setFormData((prevState) => ({
      ...prevState,
      [sectionKey]: updatedSection
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const transformedData = transformData(Fakedata);
    localStorage.setItem('myData', JSON.stringify(transformedData));

    console.log("Transformed Data:", transformedData);
    setShotemlpate(true)
  };

  return (
    <>
    <Helmet>
        <title>Create Marriage Biodata Online — Shadi Biodata Templates</title>
        <meta name="description" content="Create professional marriage biodata online with ready-to-use templates. Download biodata in PDF. Easy & secure for Indian weddings." />
        <meta name="keywords" content="marriage biodata, biodata maker, biodata for marriage, biodata template, Indian marriage biodata, wedding biodata sample" />
        
        {/* Canonical Link */}
        <link rel="canonical" href="https://shadibiodata.app/" />

        {/* OpenGraph for Social Sharing */}
        <meta property="og:title" content="Create Your Marriage Biodata Online - Shadi Biodata App" />
        <meta property="og:description" content="Simple & beautiful biodata templates for Indian weddings. Instant download in PDF!" />
        <meta property="og:url" content="https://shadibiodata.app/" />
        <meta property="og:image" content="https://shadibiodata.app/assets/biodata-preview.jpg" />

        {/* Twitter Meta */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Create Your Marriage Biodata Online" />
        <meta name="twitter:description" content="Instant marriage biodata creator for Indian weddings. Choose templates, preview, and download PDF." />
        <meta name="twitter:image" content="https://shadibiodata.app/assets/biodata-preview.jpg" />
      </Helmet>

      {!showTemlate && 
      <div>
        <section >
          <div style={{ backgroundColor: "#fcfafb" }}>
            <div className="mainBox">
              <div className="Bnner">
                <div className="LAble">
                  <h1 className="FontSize">Marriage Biodeta</h1>
                </div>
                <div style={{ position: "relative", height: "300px" }}>
                  <div className="Ftame1">
                    <img style={{ objectFit: "contain" }} src={imge4} />
                  </div>
                  <div className="Frame2">
                    <img style={{ objectFit: "contain" }} src={imge2} />
                  </div>
                  <div className="Fmare3">
                    <img style={{ objectFit: "contain" }} src={imge1} />
                  </div>
                </div>

                <div className="Eleveret">
                  <h1 className="mainline">
                    Your Personality

                    Deserves the Finest

                    Designs
                  </h1>
                </div>
                
                <button
                  className="biobutton"
                  onClick={scrollToForm}
                >
                  Create My biodata
                </button>
                <div>
                  <h2 className="secline">
                    Make a Beautiful Biodata in 3 Simple steps.
                  </h2>
                </div>
              </div>

              <div>
                <CarouselSteps />
              </div>
              <div>


                {/* <div className="P30">
                  <h3 className="Text FotnWe">
                    Beautifully Handcrafted Marriage Biodata Templates

                  </h3>
                </div> */}
                {/* <div>
                  <h2>
                    Choose from our best-designed, ready-to-use marriage biodata formats. No need to worry about layout or design — just fill in your details and download your perfect biodata for marriage in minutes
                  </h2>
                </div> */}
              </div>
              <div
                style={{
                  marginTop: "56px",
                  backgroundColor: "#80173c",
                  marginBottom: "40px",
                  color: "white",
                  paddingTop: "20px"
                }}
              >
                <div className="TEXT">
                  <h2 className="fontfam">
                    Marriage Biodata Designs                  <br />
                  </h2>
                </div>


                <div>
                  <div className="Crolse">
                    <div>
                      <img style={{ objectFit: "contain" }} src={imge1} />
                    </div>
                    <div>
                      <img style={{ objectFit: "contain" }} src={imge2} />
                    </div>
                    <div>
                      <img style={{ objectFit: "contain" }} src={imge4} />
                    </div>
                  </div>

                </div>
              </div>
              <div className="">
                <button className="biobutton">Start Creating Your Biodata</button>
              </div>

              <div ref={formRef} className="formbox" style={{ position: "relative" }}>
                <Profile setCropeimgefile={setCropeimgefile} />
                <form
                  className="mainformbox"
                  onSubmit={handleSubmit}>
                  {Object.keys(Fakedata).map((sectionKey) => (
                    <div className="inpiutdipaybox" key={sectionKey}>
                      <h3 style={{ marginLeft: "13px", marginTop: "20px" }}> {sectionKey}</h3>
                      {Fakedata[sectionKey].map((field, index) => (
                        <div className="maininputBox" style={{ width: "100%" }} key={`${sectionKey}-${index}`}>

                          <div className="Boxinput">
                            <input
                              className="inputBox"
                              style={{ backgroundColor: "#e8eaef", fontFamily: "serif" }}
                              type="text"
                              value={field.key}
                              onChange={(e) => handleKeyChange(sectionKey, index, e.target.value)}
                              disabled={!field.editable}
                            />
                            <input
                              className="inputBox"
                              type="text"
                              style={{ backgroundColor: "rgb(255 255 255)", fontFamily: "serif" }}
                              value={field.value}
                              onChange={(e) => updateData(sectionKey, index, e.target.value)}
                            />

                          </div>
                          <div>
                            <button
                              className="deletbutton"
                              type="button"
                              onClick={() => deleteField(sectionKey, index)}
                              disabled={!field.editable}
                            >
                              <img style={{ opacity: !field.editable ? 0.3 : 1 ,color:"red"}} width="30" height="30" src="https://img.icons8.com/ios-glyphs/30/delete-forever.png" alt="delete-forever"/>
                              {/* <svg 

                                xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi Buttonocn bi-x-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                              </svg> */}
                            </button>
                          </div>
                        </div>
                      ))}
                      <button style={{ width: "75%", backgroundColor: "#fffcfc", border: "1px solid #80173c", color: "black", margin: "10px " }} type="button" onClick={() => addField(sectionKey)}>
                        Add Field
                      </button>
                    </div>
                  ))}
                  <div>
                  <div className="button-wrapper " style={{ display: "flex" }}>
                    <button
                      type="submit"
                      className="biobuttondel"
                    >
                      <img className="resetpng" src={Reset} />
                      Reset Form
                    </button>
                    <button
                      type="submit"
                      className="biobuttondel"
                    >
                      Choose Design
                    </button>
                  </div>
                  

                  </div>
                  

                </form>
              </div>
            </div>
          </div>


        </section>
        <section className="accordion-wrapper">
          <h2 style={{fontWeight:700}}>
          Frequently Asked Questions
          </h2>
          {faqData.map((item, index) => (
            <article key={index} className="accordion-item">
              <header
                className={`accordion-header ${activeIndex === index ? 'open' : ''}`}
                onClick={() => toggleAccordion(index)}
                aria-expanded={activeIndex === index}
                role="button"
                tabIndex={0}
              >
                <h3 className="accordion-question">{item.question}</h3>
                <span className="accordion-icon">{activeIndex === index ? '▲' : '▼'}</span>
              </header>
              {activeIndex === index && (
                <div className="accordion-body">
                  <p>{item.answer}</p>
                </div>
              )}
            </article>
          ))}
        </section>
        <footer className="footer">
          <div className="footer-container">

            {/* Left Section - Branding */}
            <div className="footer-brand">
              <img
                src="/logo.png" // Replace with actual path to your logo
                alt="Marriage Biodata Logo"
                className="footer-logo"
              />
              <p className="footer-app-name">MarriageBiodata.App</p>
              <p className="footer-tagline">Owned by Lord Shani Dev</p>
              <div className="footer-social-icons">

              </div>
            </div>

            {/* Blog Links */}
            <nav className="footer-section" aria-labelledby="blog-heading">
              <h3 id="blog-heading" className="footer-heading">Marriage Biodata Blog</h3>
              <ul>
                <li><a href="#">Best Marriage Biodata Templates in 2025</a></li>
                <li><a href="#">How to create Marriage Biodata</a></li>
                <li><a href="#">Best Marriage Biodata Format / Templates for Girls</a></li>
                <li><a href="#">9 Point Guide to Create Your Perfect Marriage Biodata</a></li>
                <li><a href="#">What Details Should be given in Marriage Biodata</a></li>
                <li><a href="#">Kundli Matching - Horoscope Matching for Marriage</a></li>
                <li><a href="#">How to Share Resume / Marital Biodata PDF using QR Code</a></li>
              </ul>
            </nav>

            {/* Company Links */}
            <nav className="footer-section" aria-labelledby="company-heading">
              <h3 id="company-heading" className="footer-heading">Company</h3>
              <ul>
                <li><a href="#">Terms and Conditions</a></li>
                <li><a href="#">Privacy Policy</a></li>
                <li><a href="#">Refund Policy</a></li>
                <li><a href="#">Shipping Policy</a></li>
                <li><a href="#">Contact Us</a></li>
              </ul>
            </nav>

            {/* Bottom Info */}


          </div>
        </footer>
      </div>}

      {showTemlate &&
        <div>
          <TemplateEditor Cropeiagmefile={Cropeiagmefile} />


        </div>
      }
    </>
  );
}

export default Home;
